import { DELAY_TONES, PRIORITY_LABELS, STATUS_LABELS, listDelay, priorityTone, statusTone } from "../../lib/tickets";

function Pill({ tone, children, testid }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${tone}`} data-testid={testid}>
      {children}
    </span>
  );
}

// The priority, with a pencil mark when someone adjusted it by hand (the computed one stays on the ticket page).
export function PriorityBadge({ priority, adjusted = false, testid = "ticket-priority" }) {
  return (
    <Pill tone={priorityTone(priority)} testid={testid}>
      {PRIORITY_LABELS[priority] || priority}{adjusted && <span className="ml-1" title="Priorité ajustée" aria-label="ajustée">✎</span>}
    </Pill>
  );
}

export function TicketStatusBadge({ status, testid = "ticket-status" }) {
  return <Pill tone={statusTone(status)} testid={testid}>{STATUS_LABELS[status] || status}</Pill>;
}

// The list's « Délai » cell: the most urgent running delay in words, nothing once both are met or the ticket is closed.
export function DelayCell({ ticket, testid }) {
  const delay = listDelay(ticket);
  if (!delay) return <span className="text-slate-400" data-testid={testid}>—</span>;
  return <span className={`text-sm tabular-nums ${DELAY_TONES[delay.state]}`} data-testid={testid}>{delay.text}</span>;
}

// 08-4: a request received from Jamora whose CRM pharmacy nobody has confirmed yet.
export function ToAttachBadge() {
  return (
    <span className="ml-1.5 inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-1.5 py-0.5 text-2xs font-medium text-amber-800 whitespace-nowrap"
      data-testid="ticket-to-attach">
      À rattacher
    </span>
  );
}
